import React, { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface Head4Props {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  style?: React.CSSProperties;
  isClamp?: boolean;
  textBreak?: 'words' | 'characters';
  overflow?: 'hidden' | 'visible';
}

const Head4 = ({
  children,
  maxLines = 2,
  className = '',
  isClamp = false,
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: Head4Props & React.ComponentProps<'h4'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );
  return (
    <h4
      style={{ ...lineClampStyle, ...style }}
      className={`font-bold text-2xl text-black90 ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </h4>
  );
};

export default Head4;
